import { useContext, useState } from "react";
import { GraphContext } from "../routes/GraphContext";
import Button from '@mui/material/Button';

export default function Toggle2Button ({value, setter, text}) {

    const [parameter, setParameter] = useContext(GraphContext);

return (

    <>
        <Button   
            sx={{fontSize: '12x', padding: '2px'}}
            variant={value ? "contained" : "outlined"} 
            active={value}
            onClick={() => setter(!value)}
        >
            {text}
        </Button>
    </>

)

}